import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import classNames from "classnames/bind";

import { CloseIcon } from "src/assets/icons";

import styles from "./Drawer.module.scss";
const cx = classNames.bind(styles);

const Drawer = ({ data, isOpen, setIsOpen }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { delay: 0.2 } }}
          className={cx("drawer-root")}
        >
          <motion.div
            initial={{ opacity: 0, x: 500 }}
            animate={{
              opacity: 1,
              x: 0,
              transition: { delay: 0.1, duration: 0.35 },
            }}
            exit={{ opacity: 0, x: 500, transition: { duration: 0.35 } }}
            className={cx("drawer-content")}
          >
            <CloseIcon onClick={() => setIsOpen(false)} />
            <div className={cx("group")}>
              <span>Source</span>
              <span>{data.Source || "NULL"}</span>
            </div>
            <div className={cx("group")}>
              <span>IsAffliate</span>
              <span>{data.IsAffliate === "1" ? "Yes" : "No"}</span>
            </div>
            <div className={cx("group")}>
              <span>DataIssues</span>
              <span>{data.DataIssues || ""}</span>
            </div>
            <div className={cx("group")}>
              <span>TimeSinceLastSuccessScraping</span>
              <span>{data.LastSuccessScraper || ""}</span>
            </div>
            <div className={cx("group")}>
              <span>LastRunStatusScraping</span>
              <span>{data.LastRunStatusScraper || ""}</span>
            </div>
            <div className={cx("group")}>
              <span>TimeSinceLastSuccessProcessing</span>
              <span>{data.LastSuccessProcess || ""}</span>
            </div>
            <div className={cx("group")}>
              <span>LastRunStatusProcessing</span>
              <span>{data.LastRunStatusProcess || ""}</span>
            </div>
            <div className={cx("group")}>
              <span>NoOfRecordsScraping</span>
              <span>{data.ScrapeRecords || ""}</span>
            </div>
            <div className={cx("group")}>
              <span>NoOfRecordsProcessing</span>
              <span>
                {data.ProcessedRecords !== "" ? data.ProcessedRecords : "-"}
              </span>
            </div>
            <div className={cx("group")}>
              <span>%ChangeInRecordsAfterProcessing</span>
              <span>
                {data.PercentageChangeinRecords !== ""
                  ? data.PercentageChangeinRecords
                  : "-"}
              </span>
            </div>
            <div className={cx("group")}>
              <span>LogDate</span>
              <span>{data.LogDate || ""}</span>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Drawer;
